module.exports = __webpack_public_path__ + "img/woman2b.d6a83e4d.png";